import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme);
  const ex1 = await getThemePic(data?.customTheme, "ex-1");

  return {
    id: id,
    elements: [
      {
        type: "image",
        id: "SI03Aj2PJV",
        src: ex1,
        width: 577.288794305975,
        height: 435.7155899880811,
        left: -2.5733333333334265,
        top: 5.6110766785856185,
        fixedRatio: true,
        rotate: 0,
      },
      {
        type: "shape",
        id: "4mZZiGLd7Y",
        width: 1002.5733333333333,
        height: 563.68,
        left: 0,
        top: -1.0933333333333333,
        viewBox: [751.93, 422.76],
        path: " M751.9289698162729,421.8749042963127 L751.9289698162729,416.67468309834044 L730.8867290026246,411.12959032464806 C516.6514107611548,349.331009847343 473.70948162729655,175.8916562683629 368.7502460629921,145.56173331415994 C256.79371719160105,113.20988593911952 156.97465551181102,190.09308248871824 1.6304133858267715,0 L0,422.755249343832 L751.9289698162729,421.8749042963127z",
        fill: "#e64239",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#7f1610",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 16px;"><span style="font-family: 微软雅黑;">&nbsp;</span></span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: true,
        flipV: true,
        special: true,
      },
      {
        type: "shape",
        id: "8LbrPaL7TR",
        width: 331.62666666666667,
        height: 124,
        left: 670.9466666666666,
        top: -1.0933333333333333,
        viewBox: [248.72, 93],
        path: " M0,93.00295275590551 L0,0 C43.40648822847707,19.00289387536138 108.44132770944331,-6.352026720173082 157.70550762474596,14.690730934455738 C206.96968754004862,35.73348858908456 190.44810463176003,69.14839463221269 248.72399934383202,93.00295275590551 L0,93.00295275590551z",
        fill: "#ff8181",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#7f1610",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;"><span style="font-family: 微软雅黑;">&nbsp;</span></span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: true,
        flipV: true,
        special: true,
      },
      {
        type: "text",
        id: "1x05xcvDjV",
        width: 49.61333333333333,
        height: 40,
        left: 0,
        top: 0,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style="text-align: left;"><span style="font-size: 1.02px;font-family: 微软雅黑;">行业</span><span style="font-size: 1.02px;font-family: 微软雅黑;">PPT</span><span style="font-size: 1.02px;font-family: 微软雅黑;">模板</span><span style="font-size: 1.02px;font-family: 微软雅黑;">http://www.1ppt.com/hangye/</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "shape",
        id: "uWKYlk8tru",
        width: 1000,
        height: 214.64,
        left: -9.947598300641403e-14,
        top: 347.86,
        viewBox: [750, 160.98],
        path: " M0,160.98129921259843 L0,16.254593175853017 C84.59694881889763,-36.51935695538058 163.47399934383202,56.00647965879265 255.67962598425197,57.10900590551181 C379.67872375328085,50.87458989501312 439.0538057742782,-2.5944061679790025 553.2340059055118,22.86991469816273 C667.4142060367454,48.334235564304464 711.3135662729659,109.23761482939632 750.0000820209974,160.98129921259843 L0,160.98129921259843z",
        fill: "#ff8181",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#7f1610",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: 微软雅黑;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
        special: true,
      },
      {
        type: "shape",
        id: "z5Xe54wL7L",
        width: 1001.1999999999999,
        height: 200.54666666666665,
        left: -1.200000000000034,
        top: 361.9533333333334,
        viewBox: [750.9, 150.41],
        path: " M0,150.40780839895012 L0,15.186967355555115 C84.69800441501457,-34.12071135383085 163.6692778105374,52.32789089678395 255.9850490211289,53.358001582201815 C380.13227036811134,47.53307127431517 439.5782791115484,-2.4240017177840096 553.8948736204766,21.367784735535245 C668.2114681294047,45.1595711888545 712.1632685077315,102.06272605316583 750.895997375328,150.40780839895012 L0,150.40780839895012z",
        fill: "rgba(249,249,249,1)",
        fixedRatio: false,
        rotate: 0,
        outline: {
          color: "#7f1610",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: 微软雅黑;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
        special: true,
      },
      {
        type: "shape",
        id: "ZN5NksC2_u",
        width: 836.3561950167432,
        height: 121.17333333333332,
        left: 94.28212763930824,
        top: 441.3266666666667,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: "none",
        fixedRatio: false,
        rotate: 0,
        text: {
          content:
            '<p style=""><span style="font-size: 72px;"><span style="font-family: 微软雅黑;"><span style="color: rgba(215,174,174,1);">FASHION&nbsp;MAKEUP</span></span></span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "top",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "text",
        id: "3vVDt6EIQJ",
        left: 864.5354129065214,
        top: 5.6110766785856185,
        width: 82.36846586071854,
        height: 65,
        content:
          '<p style=""><span style="font-size: 30px;"><span style="color: rgba(255,255,255,1);">目录</span></span></p>',
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        vertical: false,
      },
      {
        type: "text",
        id: "xewmm4Yau2",
        left: 836.76,
        top: 60.906666666666666,
        width: 181.45326068448833,
        height: 50,
        content:
          '<p style=""><span style="color: rgba(242,242,242,1);">CONTENTS</span></p>',
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        vertical: false,
      },
      {
        type: "text",
        id: "FKQsx5EgLg",
        left: 383.4541792547834,
        top: 87.23308734055047,
        width: 361.664988251091,
        height: 241.921875,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        vertical: false,
      },
    ],
    background,
  };
}
